module.exports = __webpack_public_path__ + "img/waves.edf6b5fc.svg";